<template>
  <div class="game-session">
    <div
      :class="[`locked-bet-button`, 'text-center']"
      @click.stop="createNewOffer"
    >
      <font-awesome-icon :icon="faPlus" />
    </div>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';

const props = defineProps({
  side: {
    type: String,
    default: null,
  },
  game: {
    type: Object,
    default: null,
  },
  typeBet: {
    type: String,
    default: null,
  },
  // Optional explicit total line for new total offers. Falls back to the
  // game's main total when not provided so existing callers are unaffected.
  total: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(['makeBet']);

function createNewOffer() {
  const participant =
    props.typeBet === 'spread'
      ? props.game.participants.find((p) => p.homeAway === props.side).id
      : null;
  const spread =
    props.side === 'away'
      ? props.game.mainAwaySpread
      : props.game.mainHomeSpread;
  const dataNewOffer = {
    OU: props.typeBet === 'total' ? props.side : null,
    createdBy: 'x',
    gameID: props.game.id,
    participantID: participant,
    source: 'fillerData',
    spread: props.typeBet === 'spread' ? spread : null,
    total:
      props.typeBet === 'total'
        ? (props.total ?? props.game.mainTotal)
        : null,
    type: props.typeBet,
  };
  emit('makeBet', dataNewOffer);
}
</script>

<style scoped lang="scss">
@use '@/scss/tokens.scss' as main;

.locked-bet-button {
  padding: 0.5rem;
  position: relative;
}
</style>
